import React, { Fragment, useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Sidenav, Nav, Dropdown, Icon, IconButton, Steps } from 'rsuite'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import classNames from 'classnames'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import AppContext from '../../context/AppContext'
import { getOpenKeys } from './sidebarUtils'
import pathname, { menuType } from '../../constants/pathname'
import {
  getSchemaMultiAproveSidebar,
  getSchemaMultiReviewSidebar,
  getSchemaSidebar,
  setIsExpandedSidebar,
  getSchemaSubProjectSidebar,
  getSchemaSubProjectMainSidebar,
  getSchemaSubProjectDep6Sidebar,
  getSchemaMultiApproveReviewerSidebar,
  getMockSchemaSidebar,
  getSchemaLegalManagementSidebar,
  getSchemaDataManagementSidebar,
  getSchemaReportManagementSidebar,
  getSchemaAuditSchemaSidebar,
  getSchemaEvaluatesSchemaSidebar,
  getSchemaAccountingSidebar,
  getSchemaAccountingIncomExpenseSidebar,
  getSchemaAccountingApproverSidebar,
  getSchemaAssetCirculatingSidebar,
  getSchemaAuditExpenseSidebar,
  getSchemaWithdrawReviewSidebar,
  getAssessmentMenuSidebar,
  getSchemaSearchDataSchemaSidebar,
} from '../../redux/actions/sidebar'
import { startLoading, doneLoading } from '../../utils/loading'
import SidebarLoadingTemplate from '../../widgets/loadingTemplate/sidebarLoadingTemplate/SidebarLoadingTemplate'
import { DEFAULT_ICON_COLOR } from '../../constants/color'
import './styles.less'
import { reviewPaymentSchema } from './mock/reviewPaymentSchema'
import { searchDataSchema } from './mock/searchDataSchema'
import { previewFile } from '../../utils/fileUtil'
import { getSystemDoc } from '../../redux/actions/filesManagement'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import {
  newReviewSubProjectSchema,
  newSubProjectSchema,
  newSubProjectSettingSchema,
  oldSubProjectSchema,
} from './mock/newSubProjectSchema'
import { cloneDeep } from 'lodash-es'
import { SUB_FOLLOW_ID, SUB_FOLLOW_VM } from '../../constants/constants'

export default function SidebarProposal({
  children,
  isMultiReview,
  isMultiApprove,
  isMultiApproveReviewer,
  isSubProject,
  isSubProjectReport,
  isSubProjectDep6,
  isLegalManagement,
  isManagement,
  isReport,
  isSearch,
  isReviewPayment,
  isIncomeAndExpense,
  isIncomeExpense,
  isIncomeExpenseApprover,
  isAudit,
  isEvaluates,
  isAssetCirculating,
  isAssessment,
  hidePageToolbar = true,
  isNewSubProject,
  isNewSubProjectSetting,
  mode,
}) {
  const {
    theme: [themeName, direction],
  } = React.useContext(AppContext)

  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()
  const location = useLocation()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const expandedMenu = localStorage.getItem('expandedMenu') || 1
  // const [expanded, setExpanded] = useState(false)
  const [expanded, setExpanded] = useState(expandedMenu == 1)

  const [mediaSidebarShow, setMediaSidebarShow] = useState(false)

  const [openKeys, setOpenKeys] = useState()

  const dispatch = useDispatch()
  const { isLoading: isLoadingSidebar, data: sidebarsSchema } = useSelector(
    (state) => state.schemaSidebar
  )

  useEffect(() => {
    handleGetSchema()
  }, [projectId])

  useEffect(() => {
    // console.log('sidebarsSchema ', sidebarsSchema)

    if (sidebarsSchema) {
      let userOpenMenu = sessionStorage?.getItem('userOpenMenu')

      if (userOpenMenu) {
        sidebarsSchema.alwaysOpenKeys.push(userOpenMenu)
      }

      setOpenKeys(getOpenKeys(sidebarsSchema, location))
    }
  }, [sidebarsSchema])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      if (isMultiReview) {
        await dispatch(getSchemaMultiReviewSidebar(projectId))
      } else if (isMultiApprove) {
        let approveType = sessionStorage.getItem('param')?.substring(1)
        await dispatch(getSchemaMultiAproveSidebar(approveType, projectId))
      } else if (isSubProject || isNewSubProject) {
        await dispatch(getSchemaSubProjectSidebar(projectId))
      } else if (isSubProjectReport) {
        await dispatch(getSchemaSubProjectMainSidebar())
      } else if (isSubProjectDep6) {
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else if (isAudit) {
        await dispatch(getSchemaAuditExpenseSidebar())
      } else if (isEvaluates) {
        await dispatch(getSchemaEvaluatesSchemaSidebar())
      } else if (isMultiApproveReviewer) {
        await dispatch(getSchemaMultiApproveReviewerSidebar(projectId))
      } else if (isLegalManagement) {
        await dispatch(getSchemaLegalManagementSidebar())
      } else if (isIncomeAndExpense) {
        await dispatch(getSchemaAccountingSidebar())
      } else if (isIncomeExpense) {
        await dispatch(getSchemaAccountingIncomExpenseSidebar())
      } else if (isIncomeExpenseApprover) {
        await dispatch(getSchemaAccountingApproverSidebar())
      } else if (isReport) {
        await dispatch(getSchemaReportManagementSidebar())
      } else if (isAssetCirculating) {
        await dispatch(getSchemaAssetCirculatingSidebar())
      } else if (isReviewPayment) {
        await dispatch(getSchemaWithdrawReviewSidebar())
      } else if (isAssessment) {
        await dispatch(getAssessmentMenuSidebar())
      } else if (isSearch) {
        await dispatch(getSchemaSearchDataSchemaSidebar())
        // } else if (isManagement || projectId == 'setting') {
      } else if (isManagement) {
        //await dispatch(getMockSchemaSidebar(settingSchema))
        await dispatch(getSchemaDataManagementSidebar())
      } else if (isNewSubProject) {
        let mockSchema = cloneDeep(newSubProjectSchema)

        const projectId = sessionStorage.getItem('projectId')

        mockSchema.menu = projectId

        mockSchema.sidebars[1].items.push({
          eventKey: 'PROPOSAL_MENU_SUBMIT',
          icon: {
            name: 'send',
            color: '#2da888',
          },
          link: pathname.subProjectNew.proposalSubmit,
          children: 'ยื่นข้อเสนอโครงการ',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        })

        await dispatch(getMockSchemaSidebar(mockSchema))
      } else if (isNewSubProjectSetting) {
        await dispatch(getMockSchemaSidebar(newSubProjectSettingSchema))
        // } else if (isNewReviewSubProject) {
        //   await dispatch(getMockSchemaSidebar(newReviewSubProjectSchema))
      } else if (projectId != '' && projectId != null && projectId != undefined) {
        await dispatch(getSchemaSidebar(projectId))
      }
    } catch (e) {
      console.error(e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetManualFile = async (pathFile) => {
    try {
      const file = await getSystemDoc(pathFile)
      var fileName = pathFile?.split('/')?.pop()

      previewFile(file, fileName)
    } catch (e) {
      //console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
  }

  function handleToggleMenu() {
    var isExpanded

    setExpanded((s) => {
      isExpanded = !s
      dispatch(setIsExpandedSidebar(!s))
      return !s
    })

    localStorage.setItem('expandedMenu', isExpanded ? 1 : 0)
  }

  const handleOpenMediaSidebar = useCallback(() => {
    setMediaSidebarShow(true)
  }, [setMediaSidebarShow])

  const handleCloseMediaSidebar = useCallback(() => {
    setMediaSidebarShow(false)
  }, [setMediaSidebarShow])

  const generateNav = (section) => {
    return (
      <Fragment key={section.id}>
        {section.items.map((item) => {
          const link = `${item.link}`

          return (
            <Nav.Item
              key={item.eventKey}
              eventKey={item.eventKey}
              icon={
                <Icon
                  icon={item.icon?.name || ''}
                  style={
                    item.icon?.color
                      ? { color: item.icon.color }
                      : location.pathname === link &&
                          (!sessionStorage.getItem('param') ||
                            sessionStorage.getItem('param') === item.param)
                        ? {}
                        : { color: themeName === 'dark' ? '' : DEFAULT_ICON_COLOR }
                  }
                />
              }
              onClick={() => {
                sessionStorage.setItem('projectId', sidebarsSchema.menu)
                sessionStorage.setItem('param', item.param ? item.param : '')
                sessionStorage.setItem('userOpenMenu', section.id)
                //sessionStorage.setItem(SUB_FOLLOW_ID, '')
                //sessionStorage.setItem(SUB_FOLLOW_VM, false)
                sessionStorage.removeItem(SUB_FOLLOW_ID)
                sessionStorage.removeItem(SUB_FOLLOW_VM)

                // sessionStorage.setItem('oldUserOpenMenu', sessionStorage.getItem('userOpenMenu'))
                // sessionStorage.removeItem('userOpenMenu')

                sessionStorage.removeItem('contract_change_id')

                if (link.startsWith('system-doc/manual')) {
                  handleGetManualFile(link)
                } else {
                  history.push({
                    pathname: link,
                    search: item.param ? item.param : null,
                  })
                }
              }}
              active={
                location.pathname === link &&
                (!sessionStorage.getItem('param') || sessionStorage.getItem('param') === item.param)
              }
              disabled={item.isDisabled}
            >
              <span dangerouslySetInnerHTML={{ __html: item.children }} />
            </Nav.Item>
          )
        })}
        {section.haveEndSectionLine && <hr />}
      </Fragment>
    )
  }

  const generateDropdown = (section) => {
    const haveEnable = !!section.items?.filter((i) => i.isDisabled !== true).length
    return (
      <Fragment key={section.id}>
        <Dropdown
          placement={section.titleItem.placement}
          eventKey={section.titleItem.eventKey}
          title={section.titleItem.title}
          icon={<Icon icon={section.titleItem?.icon || ''} />}
          disabled={!haveEnable}
        >
          {section.items?.map((item) => {
            const link = `${item.link}`
            return (
              <Dropdown.Item
                key={item.eventKey}
                eventKey={item.eventKey}
                icon={
                  <Icon
                    icon={item.icon?.name || ''}
                    style={
                      item.icon?.color
                        ? { color: item.icon.color }
                        : { color: themeName === 'dark' ? '' : DEFAULT_ICON_COLOR }
                    }
                  />
                }
                onClick={() => {
                  sessionStorage.setItem('projectId', sidebarsSchema.menu)
                  sessionStorage.setItem('param', item.param ? item.param : '')
                  sessionStorage.setItem('userOpenMenu', section.id)
                  //sessionStorage.setItem(SUB_FOLLOW_ID, '')
                  //sessionStorage.setItem(SUB_FOLLOW_VM, false)
                  sessionStorage.removeItem(SUB_FOLLOW_ID)
                  sessionStorage.removeItem(SUB_FOLLOW_VM)

                  sessionStorage.removeItem('contract_change_id')

                  if (link.startsWith('system-doc/manual')) {
                    handleGetManualFile(link)
                  } else {
                    history.push({
                      pathname: link,
                      search: item.param ? item.param : null,
                    })
                  }
                }}
                active={
                  location.pathname === link &&
                  (!sessionStorage.getItem('param') ||
                    sessionStorage.getItem('param') === item.param)
                }
                disabled={item.isDisabled}
              >
                <span dangerouslySetInnerHTML={{ __html: item.children }} />
              </Dropdown.Item>
            )
          })}
        </Dropdown>
        {section.haveEndSectionLine && <hr />}
      </Fragment>
    )
  }

  const generateStep = (section) => {
    return (
      <Fragment key={section.id}>
        <div className="sidebar-step">
          {expanded && (
            <div style={{ width: 44 * section.numberOfStep }}>
              <Steps current={section.currentStep - 1} small={true}>
                {[...Array(section.numberOfStep)].map((_, index) => {
                  return <Steps.Item key={index} />
                })}
              </Steps>
            </div>
          )}
        </div>
        {section.haveEndSectionLine && <hr />}
      </Fragment>
    )
  }

  const generateSidebar = () => {
    if (isLoading) {
      return <SidebarLoadingTemplate />
    } else if (sidebarsSchema) {
      return (
        <Sidenav
          expanded={expanded}
          openKeys={openKeys}
          onOpenChange={(_openKeys) => {
            setOpenKeys(_openKeys)
          }}
        >
          <Sidenav.Body>
            <Nav style={{ paddingBottom: 100 }}>
              {generateSidebarChildren(sidebarsSchema.sidebars)}
            </Nav>
          </Sidenav.Body>
        </Sidenav>
      )
    }
  }

  const generateSidebarChildren = (sections) => {
    return sections.map((section) => {
      if (section.type === 'nav') {
        return generateNav(section)
      } else if (section.type === 'dropdown') {
        return generateDropdown(section)
      } else if (section.type === 'step') {
        return generateStep(section)
      }
    })
  }

  return (
    <>
      <div
        className={classNames('rs-sidebar-media-backdrop', {
          'media-sidebar-show': mediaSidebarShow,
        })}
        onClick={handleCloseMediaSidebar}
      />
      <TopLevelNav />

      {hidePageToolbar && <PageToolbar />}

      <IconButton
        className="media-toggle-side-bar"
        icon={<Icon icon="bars" />}
        onClick={handleOpenMediaSidebar}
      />
      <div
        className={classNames('toggle-btn', {
          'not-expanded': !expanded,
        })}
      >
        <IconButton
          circle
          className="btn-nav-toggle"
          appearance="default"
          style={{ backgroundColor: themeName === 'dark' ? '#25b3f5' : '#2da888' }}
          icon={<Icon icon={expanded ? 'angle-left' : 'angle-right'} style={{ color: 'white' }} />}
          size="sm"
          onClick={handleToggleMenu}
        />
      </div>
      <div
        className={classNames('rs-sidebar-wrapper fixed', {
          'media-sidebar-show': mediaSidebarShow,
          'not-expanded': !expanded,
        })}
      >
        {generateSidebar()}
      </div>
      <div
        className={classNames('content', {
          'not-expanded': !expanded,
        })}
        style={{ marginBottom: 30 }}
      >
        {children}
      </div>
    </>
  )
}
